import { syncAccountInfo } from "fe2/Actions/ActionAccount";
import { waitForClanCreation } from "fe2/Actions/ActionClanCreate";
import { AccountInfoSyncManager } from "fe2/Components/UIKit/UIKit";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  isFetching: state.fetchingCounter.counter > 0
});

const mapDispatchToProps = dispatch => ({
  syncAccountInfo: () => dispatch(syncAccountInfo()),
  waitForClanCreation: () => dispatch(waitForClanCreation())
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfoSyncManager);